import { render, staticRenderFns } from "./DdQuillEditor.vue?vue&type=template&id=47fd77ed&scoped=true&"
import script from "./DdQuillEditor.vue?vue&type=script&lang=js&"
export * from "./DdQuillEditor.vue?vue&type=script&lang=js&"
import style0 from "./DdQuillEditor.vue?vue&type=style&index=0&id=47fd77ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd77ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
